<template>
  <mdb-container fluid>
    <material-card
      title="Mobilisationsprotokoll"
      card-icon="heartbeat"
    >
      <template v-slot:actions>
        <mdb-btn
          color="#333"
          class="py-2 px-3 z-depth-0 border border-light rounded"
          @click="modal=!modal"
        >
          <mdb-icon
            color="black"
            icon="plus"
          />
        </mdb-btn>
      </template>
      <template v-slot:content>
        <div class="d-flex justify-content-center">
          <mdb-spinner big v-if="loading"/>
        </div>
        <mdb-row
          v-if="protocol.length > 0"
        >
          <mdb-col
            v-for="(mobility, index) in protocol"
            :key="index"
            sm="6" md="6" lg="6" xl="4"
          >
            <mdb-card narrow>
              <mdb-card-body cascade>
                <mdb-card-text
                  class="mt-2"
                >
                  <span class="">{{ mobility.Username }}</span>
                  <span class="float-right blue-text pb-2 pt-1 ml-1">
                    <p class="h6"><mdb-icon far icon="clock" /> {{ mobility.Datum | dateFormat }}</p>
                  </span>
                </mdb-card-text>
                <mdb-card-title class="mb-0">
                  <strong class="h5 d-inline-block mb-0"><mdb-icon icon="bed" /> {{ mobility.Art }}</strong>
                </mdb-card-title>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
        </mdb-row>
        <list-group-item
          v-else
          :title="'Keine Einträge gefunden'"
        />
      </template>
    </material-card>
    <add-mobility-protocol-modal
      :modal-state="modal"
      @close="modal = false"
      @save="saveModal"
    />
  </mdb-container>
</template>

<script>
import {
  mdbContainer,
  mdbBtn,
  mdbIcon,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbSpinner
} from 'mdbvue';
const AddMobilityProtocolModal = () => import('@/components/modals/AddMobilityProtocolModal')
const MaterialCard = () => import('@/components/card/MaterialCard')
const ListGroupItem = () => import('@/components/accordion/ListGroupItem')
import utils from '@/mixins/Utils'

export default {
  name: 'Mobilisationsprotokoll',
  mixins: [utils()],
  components: {
    mdbContainer,
    mdbBtn,
    mdbIcon,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    AddMobilityProtocolModal,
    MaterialCard,
    ListGroupItem,
    mdbSpinner
  },
  data () {
    return {
      modal: false,
      loading: false,
      protocol: []
    }
  },

  created() {
    this.loadProtocol()
  },

  methods: {
    loadProtocol() {
      this.loading = true
      this.$http.get(`/Mobilisationsprotokoll/${this.roomID}`)
        .then(res => {
          if(res.data.data) {
            this.protocol = res.data.data
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    saveModal () {
      this.modal = false
      this.loadProtocol()
    }
  }
}
</script>
<style>
